import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { CODE_LISTS } from 'constants/enums'
import { codeLists as codeListsApi } from 'redux/modules/api'

function decorator(lists, config = {}) {
  return ComposedComponent => {
    @connect(
      ({ api }) => ({
        codeLists: api.codeLists
      }),
      { ...codeListsApi }
    )
    class CodeLists extends Component {
      static propTypes = {
        getPublicLists: PropTypes.func.isRequired,
        getLists: PropTypes.func.isRequired,
        codeLists: PropTypes.object.isRequired
      }

      componentDidMount() {
        const { codeLists } = this.props
        let listsToDownload = []

        for (const listItem of lists) {
          listsToDownload = listsToDownload.concat(
            CODE_LISTS.list
              .filter(
                item =>
                  item.label === listItem &&
                  (codeLists[listItem] && !codeLists[listItem].loaded)
              )
              .map(item => item.value)
          )
        }

        if (listsToDownload.length > 0) {
          this.handleListDownload(listsToDownload.join(','))
        }
      }

      handleListDownload = listsToDownload => {
        !config.public && this.props.getLists(listsToDownload)
        config.public && this.props.getPublicLists(listsToDownload)
      }

      render() {
        return <ComposedComponent {...this.props} />
      }
    }
    return CodeLists
  }
}

export default decorator
